<template>
    <div>
        <v-row v-if="indicator == 'kcpSpecialty'">
            <v-col md="6" v-if="this.$model.modules.kcp.model.isDir || this.$model.isAdmin">
                <v-tooltip location="top" text="Добавить специальность">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-plus" v-bind="props" @click="
                            addSpecDialog = true;
                        addFormEducation = '';
                        addBaseEducation = '';
                        addSpecId = '';
                        disableSomeSpec('add');
                        ">
                        </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip location="top" text="Удалить специальность">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-delete" v-bind="props" @click="
                            delSpecDialog = true;
                        disableSomeSpec('delete');
                        ">
                        </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip v-if="!isMinObrHost" location="top" text="Загрузить из конфигуратора">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-database-arrow-down-outline" v-bind="props"
                            @click="reloadReportData()">
                        </v-btn>
                    </template>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row v-if="indicator == 'kcp'">
            <v-col md="6">
                <v-tooltip location="top" v-if="step == 0 && (!isMinObrHost || isDirector)"
                    text="Добавить специальность">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-plus" v-bind="props" @click="
                            addSpecDialog = true;
                        addFormEducation = '';
                        addBaseEducation = '';
                        addSpecId = '';
                        disableSomeSpec('add');
                        ">
                        </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip location="top" v-if="isDirector || !isMinObrHost" text="Удалить специальность">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-delete" v-bind="props" @click="
                            delSpecDialog = true;
                        disableSomeSpec('delete');
                        ">
                        </v-btn>
                    </template>
                </v-tooltip>

                <v-tooltip location="top" v-if="!isMinObrHost" text="Загрузить из конфигуратора">
                    <template v-slot:activator="{ props }">
                        <v-btn variant="text" color="primary" icon="mdi-database-arrow-down-outline" v-bind="props"
                            @click="reloadReportData()">
                        </v-btn>
                    </template>
                </v-tooltip>
            </v-col>
        </v-row>

        <span v-if="$model.modules.kcp.isMinObr && indicator == 'kcp'">
            Всего заявок {{ allCount }} / утверждено {{ approvedCount }}
        </span>

        <p v-if="indicator == 'kcpSpecialty'">(форма 6 конкурсной документации)</p>
        <p v-if="indicator == 'kcpOrganization'">(форма 7 конкурсной документации)</p>

        <v-tooltip text="Копировать таблицу" location="top">
            <template v-slot:activator="{ props }">
                <v-btn variant="text" density="compact" v-bind="props" @click="copy" icon="mdi-content-copy"></v-btn>
            </template>
        </v-tooltip>


        <v-data-table ref="kcptable" :headers="table.headers" :items="table.rows" :hide-default-footer="true"
            :items-per-page="-1" item-value="0_" v-model:expanded="expanded">



            <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                <tr>
                    <th v-for="column in columns" :key="column.key">
                        <v-tooltip location="top" :text="column.title" max-width="800">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props" class="hide-long-text">
                                    {{ column.title }}
                                </div>
                            </template>
                        </v-tooltip>
                    </th>
                </tr>
            </template>


            <template v-slot:body="{ items }" v-if="isDirector || !isMinObrHost">
                <tr v-for="(item, idx) in items" :key="idx">
                    <td v-for="(val, key) in item" :key="key" @click.stop="editItem(idx, key)"
                        :style="(indicator == 'kcpOrganization' && calculatedOrgData.includes(key)) ||
                            (indicator == 'kcpSpecialty' && calculatedSpecData.includes(key)) ? 'background-color:lightgray' : ''">
                        <div v-if="key != 'childNodes_'">
                            <div v-if="
                                $model.modules.kcp.isMinObr ||
                                ((key == '0_' || key == '1_') && indicator == 'kcp') ||
                                ((key == '0_') && indicator == 'kcpSpecialty') ||
                                !editedCell ||
                                idx != editedCell.rowNum ||
                                key != editedCell.colNum ||
                                !editable||
                                (minobrApproved[idx] != -1 && indicator == 'kcp') ||
                                indicator == 'kcpOrganization' && calculatedOrgData.includes(key) ||
                                indicator == 'kcpSpecialty' && calculatedSpecData.includes(key)
                            ">
                                <span v-if="
                                    key != '0_' &&
                                    minobrApproved[idx] != -1 &&
                                    indicator == 'kcp'
                                ">{{ val }}
                                    <template v-if="key == '2_'">
                                        <span v-if="minobrApproved[idx].minobrOchka > val" style="color: green">({{
                                            minobrApproved[idx].minobrOchka}}<v-icon> mdi-arrow-up-thin
                                            </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrOchka < val" style="color: red">({{
                                            minobrApproved[idx].minobrOchka
                                            }}<v-icon> mdi-arrow-down-thin </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrOchka" style="color: green">({{ minobrApproved[idx].minobrOchka }})</span>
                                    </template>


                                    <template v-if="key == '3_'">
                                        <span v-if="minobrApproved[idx].minobrOchkaZaochka > val"
                                            style="color: green">({{ minobrApproved[idx].minobrOchkaZaochka }}<v-icon>
                                                mdi-arrow-up-thin </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrOchkaZaochka < val"
                                            style="color: red">({{
                                                minobrApproved[idx].minobrOchkaZaochka
                                            }}<v-icon> mdi-arrow-down-thin </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrOchkaZaochka" style="color: green">({{
                                            minobrApproved[idx].minobrOchkaZaochka}})</span>
                                    </template>


                                    <template v-if="key == '4_'">
                                        <span v-if="minobrApproved[idx].minobrZaochka > val" style="color: green">({{
                                            minobrApproved[idx].minobrZaochka}}<v-icon> mdi-arrow-up-thin
                                            </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrZaochka < val" style="color: red">({{
                                            minobrApproved[idx].minobrZaochka
                                            }}<v-icon> mdi-arrow-down-thin </v-icon>)</span>
                                        <span v-else-if="minobrApproved[idx].minobrZaochka" style="color: green">({{
                                            minobrApproved[idx].minobrZaochka}})</span>
                                    </template>


                                </span>
                                <template v-else>
                                    <span v-if="indicator == 'kcpOrganization' && key == '12_'">
                                        {{ idicator11title(val) }}
                                    </span>

                                    <span v-else-if="indicator == 'kcpOrganization' && calculatedOrgData.includes(key) ||
                                        indicator == 'kcpSpecialty' && calculatedSpecData.includes(key)">{{
                                            val
                                        }}</span>
                                    <span v-else>{{ val }}</span>
                                </template>
                            </div>
                            <div v-else>


                                <v-select v-if="indicator == 'kcpOrganization' && key == '12_'"
                                    :items="indicator11Values" item-title="title" item-value="value" v-model="item[key]"
                                    @update:modelValue="saveItemAndClose()">
                                </v-select>


                                <v-text-field v-else class="pointer" v-model="item[key]" dense single-line
                                    :autofocus="true" :rules="rules.numbers" @keypress="validateNumber(event)"
                                    @blur="closeEditingCell()" v-on:keyup.enter="saveItemAndClose()"
                                    @change="saveItemAndClose()">
                                </v-text-field>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <!--expanded row-->
            <template v-if="($model.modules.kcp.isMinObr && !ogrn)" v-slot:expanded-row="{ index, item }">
                <tr v-for="(row, numRow) in item.childNodes_" :key="numRow" style="background-color: lavender">
                    <td v-for="(col, numCol) in row" :key="numCol" @click.stop="editItem(numRow, numCol, index)">
                        <span v-if="numCol == 0">&nbsp;&nbsp;&nbsp;</span>


                        <span v-if="
                            numCol == 0 ||
                            !editedCell ||
                            numRow != editedCell.rowNum ||
                            numCol != editedCell.colNum ||
                            index != editedCell.indexRow
                        ">
                            <span
                                v-if="minobrApproved[item['0_']][item.childNodes_[numRow][0]] != -1 && numCol != 0 && numCol != 1">
                                <template v-if="numCol == 2">{{
                                    minobrApproved[item['0_']][item.childNodes_[numRow][0]].minobrOchka }}
                                    (запрошено: {{ col }})</template>
                                <template v-if="numCol == 3">{{
                                    minobrApproved[item['0_']][item.childNodes_[numRow][0]].minobrOchkaZaochka }}
                                    (запрошено: {{ col }})</template>
                                <template v-if="numCol == 4">{{
                                    minobrApproved[item['0_']][item.childNodes_[numRow][0]].minobrZaochka }}
                                    (запрошено: {{ col }})</template>
                            </span>
                            <span v-else>{{ col }}</span>
                        </span>


                        <v-text-field class="pointer" v-else v-model="item.childNodes_[numRow][numCol]" dense
                            single-line :autofocus="true" :rules="rules.numbers" @keypress="validateNumber(event)"
                            v-on:keyup.enter="editedCell = null" @blur="editedCell = null">
                        </v-text-field>
                    </td>
                    <td>
                        <v-btn icon="mdi-content-save-check" size="x-small" @click="saveItemAndClose(row, item['0_'])">
                            <v-icon v-if="
                                minobrApproved &&
                                minobrApproved[item['0_']][item.childNodes_[numRow][0]] != -1
                            " color="green">
                                mdi-content-save-check
                            </v-icon>
                            <v-icon v-else>mdi-content-save-check</v-icon>

                            <v-tooltip activator="parent" location="top">
                                Утвердить цифры
                            </v-tooltip>
                        </v-btn>
                    </td>
                </tr>
            </template>

            <template v-slot:bottom> </template>
        </v-data-table>

        <v-overlay v-model="overlay" class="align-center justify-center">
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular></v-overlay>

        <v-dialog v-model="addSpecDialog" width="600">
            <v-card>
                <v-card-title class="grey lighten-4">Добавить специальность</v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-autocomplete variant="underlined" :items="specialtiesList" v-model="addSpecId"
                                    label="Специальность" item-value="id" item-title="name">
                                    <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" :disabled="item.disabled"></v-list-item>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="grey lighten-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="addSpecialty()">Добавить</v-btn>
                    <v-btn color="primary" @click="addSpecDialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="delSpecDialog" width="600">
            <v-card>
                <v-card-title class="grey lighten-4">Удалить специальность</v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-autocomplete variant="underlined" :items="specialtiesList" v-model="delSpecId"
                                    label="Специальность" item-value="id" item-title="name">
                                    <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" :disabled="item.disabled"></v-list-item>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="grey lighten-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="delSpecialty()">Удалить</v-btn>
                    <v-btn color="primary" @click="delSpecDialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        ogrn: {
            required: true,
        },
        year: {
            required: true,
        },
        step: {
            required: true,
        },
        indicator: {
            required: true,
        },
        isMinObrHost: false,
        isDirector: false,
        editable: true,
    },
    data() {
        return {
            rules: {
                numbers: [
                    (value) => {
                        const pattern = /^[+-]?\d+(\.\d+)?$/;
                        return pattern.test(value) || "Только число";
                    },
                ],
            },
            indicator11Values: [
                { title: 'В наличии лаборатории и современные мастерские', value: 10 },
                { title: 'В наличии или лаборатория, или современная мастерская', value: 5 },
                { title: 'Отсутствуют', value: 0 },
            ],
            table: {
                headers: [],
                rows: [],
            },
            expanded: [],
            approved: false,
            lastsendings: "никогда",
            editedCell: null,
            overlay: false,
            addSpecDialog: false,
            delSpecDialog: false,
            specialtiesList: [],
            addSpecId: "",
            delSpecId: "",
            minobrApproved: [],
            approvedCount: 0,
            allCount: 0,
            calculatedOrgData: ['0_', '3_', '6_', '9_', '13_'],
            calculatedSpecData: ['3_', '6_', '9_', '12_']
        };
    },
    watch: {
        step: function (newVal) {
            this.loadData();
        },
        year: function (newVal) {
            this.loadData();
        },
        ogrn: function (newVal) {
            this.loadData();
        },
    },
    created() {
        this.getspecialties();
        this.loadData();
    },
    methods: {
        idicator11title(val) {
            let r = this.indicator11Values.find((el) => el.value == val)
            return r.title;
        },
        loadData() {
            this.overlay = true;
            let params = {
                year: this.year,
                step: this.step,
                ogrn: this.ogrn,
                indicator: this.indicator,
            };
            if (
                this.indicator == "kcpOrganization" ||
                this.indicator == "kcpSpecialty"
            ) {
                delete params.step;
            }

            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/getIndicator",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.dataReceive(resp.data);
                })
                .catch((reject) => {
                    this.rejectCallback(reject);
                });
        },
        editItem(rowNum, colNum, indexRow) {
            this.editedCell = {};
            this.editedCell.rowNum = rowNum;
            this.editedCell.colNum = colNum;
            this.editedCell.indexRow = indexRow;
        },
        validateNumber(evt) {
            evt = evt ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            }
            return true;
        },
        closeEditingCell() {
            this.editedCell = null;
        },
        saveItemAndClose(evt, disc) {
            console.log(evt, disc)
            if (evt) {
                return this.approveItem(evt, disc);
            }

            this.saveItem();
            this.closeEditingCell();
        },
        approveItem(evt, disc) {
            let d = evt.concat([disc]);
            let params = {
                year: this.year,
                step: this.step,
                ogrn: this.ogrn,
                data: JSON.stringify(d),
                indicator: this.indicator,
            };
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/setApprovedData",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.dataReceive(resp.data);
                    this.overlay = false;
                })
                .catch((reject) => {
                    this.overlay = false;
                    this.rejectCallback(reject);
                });
        },
        saveItem() {
            let data = this.table.rows.map((data) => {

                if (this.indicator == 'kcpOrganization') {
                    data["0_"] = parseInt(data["2_"]) ? (parseInt(data["1_"]) * 100 / parseInt(data["2_"])).toFixed(2) : 0
                    data["3_"] = parseInt(data["5_"]) ? (parseInt(data["4_"]) * 100 / parseInt(data["5_"])).toFixed(2) : 0
                    data["6_"] = parseInt(data["8_"]) ? (parseInt(data["7_"]) * 100 / parseInt(data["8_"])).toFixed(2) : 0
                    data["9_"] = parseInt(data["11_"]) ? (parseInt(data["10_"]) * 100 / parseInt(data["11_"])).toFixed(2) : 0
                    data["13_"] = parseInt(data["15_"]) ? (parseInt(data["14_"]) * 100 / parseInt(data["15_"])).toFixed(2) : 0
                }

                if (this.indicator == 'kcpSpecialty') {
                    data["3_"] = parseInt(data["5_"]) ? (parseInt(data["4_"]) * 100 / parseInt(data["5_"])).toFixed(2) : 0
                    data["6_"] = parseInt(data["8_"]) ? (parseInt(data["7_"]) * 100 / parseInt(data["8_"])).toFixed(2) : 0
                    data["9_"] = parseInt(data["11_"]) ? (parseInt(data["10_"]) * 100 / parseInt(data["11_"])).toFixed(2) : 0
                    data["12_"] = parseInt(data["14_"]) ? (parseInt(data["13_"]) * 100 / parseInt(data["14_"])).toFixed(2) : 0
                }

                if (this.indicator == 'kcp') {
                    data["1_"] = parseInt(data["2_"]) + parseInt(data["3_"]) + parseInt(data["4_"])
                }

                delete data.childNodes_;
                return Object.values(data);
            });

            let params = {
                year: this.year,
                step: this.step,
                ogrn: this.ogrn,
                data: JSON.stringify(data),
                indicator: this.indicator,
            };
            if (
                this.indicator == "kcpOrganization" ||
                this.indicator == "kcpSpecialty"
            ) {
                delete params.step;
            }

            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/procollege/report/minobr/kcp/setData",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.approved = false;
                    this.overlay = false;
                })
                .catch((reject) => {
                    this.overlay = false;
                    this.rejectCallback(reject);
                });
        },
        disableSomeSpec(actionType) {
            this.specialtiesList.forEach((spec) => {
                if (actionType == "add") {
                    spec.disabled = false;
                    this.table.rows.forEach((row) => {
                        if (spec.name == row["0_"]) {
                            spec.disabled = true;
                        }
                    });
                }

                if (actionType == "delete") {
                    spec.disabled = true;
                    this.table.rows.forEach((row) => {
                        if (spec.name == row["0_"]) {
                            spec.disabled = false;
                        }
                    });
                }
            });
        },
        getspecialties() {
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/getSpecialties",
                    null,
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.specialtiesList = resp.data;
                    this.disableSomeSpec("add");
                })
                .catch((reject) => {
                    this.rejectCallback(reject);
                });
        },
        addSpecialty() {
            let step = this.step ?? "";
            let params = {
                year: this.year,
                step: step,
                ogrn: this.ogrn,
                indicator: this.indicator,
                id: this.addSpecId,
            };
            this.overlay = true;
            this.addSpecDialog = false;
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/addSpecialty",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.overlay = false;
                    this.addSpecId = "";
                    this.dataReceive(resp.data);
                })
                .catch((reject) => {
                    this.overlay = false;
                    this.rejectCallback(reject);
                });
        },
        reloadReportData() {
            let step = this.step ?? "";
            let params = {
                step: step,
                year: this.year,
                ogrn: this.ogrn,
                indicator: this.indicator,
            };
            this.overlay = true;
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/reloadReportData",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.overlay = false;
                    this.dataReceive(resp.data);
                })
                .catch((reject) => {
                    this.overlay = false;
                    this.rejectCallback(reject);
                });
        },
        delSpecialty() {
            let step = this.step ?? "";
            let params = {
                year: this.year,
                step: step,
                ogrn: this.ogrn,
                indicator: this.indicator,
                id: this.delSpecId,
            };
            this.overlay = true;
            this.delSpecDialog = false;
            this.axios
                .post(
                    this.$model.wwwroot + "/procollege/report/minobr/kcp/delSpecialty",
                    new URLSearchParams(params),
                    {
                        headers: {
                            Accept: "application/json",
                            "Content-type":
                                "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    }
                )
                .then((resp) => {
                    this.overlay = false;
                    this.delSpecId = "";
                    this.dataReceive(resp.data);
                })
                .catch((reject) => {
                    this.overlay = false;
                    this.rejectCallback(reject);
                });
        },
        copy() {
            let el = this.$refs.kcptable.$el;
            var body = document.body,
                range,
                sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
            }
            document.execCommand("Copy");
        },
        dataReceive(resp) {
            this.minobrApproved = resp.minobrApproved;

            this.overlay = false;
            let t = [];
            this.table.rows = [];
            this.table.headers = [];
            if (resp.data.length == 0) {
                t[0] = {};
            } else {
                t = resp.data;
            }

            if (resp.allCount) {
                this.allCount = resp.allCount;
                this.approvedCount = resp.approvedCount;
            }

            this.approved = resp.approved;
            resp.indicators.forEach((el, index) => {
                if (el.title != undefined) {
                    let children = [];
                    el.children.forEach((child) => {
                        children.push({
                            title: child,
                            key: index + child,
                        });
                    });
                    this.table.headers.push({
                        title: el.title,
                        key: index + "_",
                        children: children,
                    });
                } else {
                    this.table.headers.push({
                        title: el,
                        key: index + "_",
                    });
                }
                if (resp.data.length == 0) {
                    t[0][index] = 0;
                }
            });

            t.forEach((el) => {
                let d = {};
                for (let i in el) {
                    d[i + "_"] = el[i];
                }

                this.table.rows.push(d);
            });

            if (
                (this.indicator == "kcp" || this.indicator == "kcpSpecialty") &&
                resp.data.length == 0
            ) {
                this.table.rows = [];
            }

            if (
                this.$model.modules.kcp.model.isMinObr &&
                !this.ogrn &&
                this.indicator == "kcp"
            ) {
                this.table.headers.push({
                    title: "Подробнее",
                    key: "data-table-expand",
                });
            }

            /*
      
            this.table.headers=[
                {
                  title: 'Dessert (100g serving)',
                  align: 'start',
                  sortable: false,
                  key: '0_',
                },
                { title: 'Calories', key: '1_' },
                { title: 'Fat (g)', key: '2_' },
                { title: 'Carbs (g)', key: '3_' },
                { title: 'Protein (g)', key: '4_' },
                { title: 'Iron (%)', key: '5_' },
                { title: 'dsrg', key: 'data-table-expand' },
            ];
      
            this.table.rows = [ {
                  "0_": 'Frozen Yogurt',
                  "1_": 159,
                  "2_": 6.0,
                  "3_": 24,
                  "4_": 4.0,
                  "5_": 1,
                  childNodes: [
                    {
                      first: 1,
                      second: 2,
                      third: 3,
                      fourth: 4,
                      fifth: 5,
                      sixth: 6,
                    },
                    {
                      first: 9,
                      second: 8,
                      third: 7,
                      fourth: 6,
                      fifth: 5,
                      sixth: 4,
                    },
                  ],
                }];
        */
        },
        rejectCallback(reject) {
            this.overlay = false;
            if (reject.response != undefined && reject.response.data != undefined) {
                let m = reject.response.data;
                try {
                    JSON.parse(m);
                } catch (e) { }
                m = m instanceof String || typeof m === "string" ? m : m.message;
                console.log(m);
                this.$eventBus.$emit("show-dialog", {
                    title: "Ошибка",
                    content: m,
                });
            }
        },
    },
};
</script>
<style scoped>
div.v-table>button.v-btn {
    max-width: 200px;
    align-self: end;
}

.pointer {
    cursor: pointer;
}

.hide-long-text {
    max-height: 150px;
    overflow: hidden;
}
</style>
